var _rect, _path, _path2, _path3, _rect2, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.51587 7.3542C7.07953 8.03492 6.4221 9.06617 6.05525 9.64587C5.36463 10.7367 5.01667 10.9671 5.01667 10.3334C5.01667 10.0111 4.89438 9.9667 4.00833 9.9667H3V10.6084V11.25H3.91667C4.4454 11.25 4.83333 11.3331 4.83333 11.4462C4.83333 11.554 4.58583 12.0021 4.28333 12.4417L3.73333 13.241V16.6455C3.73333 19.9277 3.74653 20.05 4.1 20.05C4.41772 20.05 4.46667 20.1723 4.46667 20.9667V21.8834H5.2H5.93333V20.9667V20.05H14H22.0667V20.9667V21.8834H22.8917H23.7167V20.9667C23.7167 20.2741 23.784 20.05 23.9917 20.05C24.2263 20.05 24.2665 19.5462 24.2659 16.6125L24.265 13.175L23.7167 12.35C23.4151 11.8963 23.1679 11.4631 23.1674 11.3875C23.167 11.312 23.5792 11.25 24.0833 11.25H25V10.6084V9.9667H23.9917C23.1056 9.9667 22.9833 10.0111 22.9833 10.3334C22.9833 11.0616 22.6124 10.6608 21.2059 8.4124L19.775 6.12495L14.0422 6.12073L8.30933 6.1167L7.51587 7.3542ZM14.825 8.07617C14.5225 8.3409 13.417 9.30762 12.3683 10.2246L10.4617 11.8917L14.403 11.941L18.3444 11.9903L19.5638 13.3475C20.2346 14.0939 20.7833 14.7491 20.7833 14.8036C20.7833 14.858 19.4839 15.5334 17.8958 16.3043C14.0842 18.1549 13.0364 18.6243 13.1592 18.4255C13.2152 18.335 14.2171 17.4878 15.3856 16.5431L17.5103 14.825L14.1509 14.7334L10.7917 14.6417L9.6638 13.45C9.04358 12.7946 8.36855 12.0521 8.16395 11.8L7.79178 11.3417L11.4918 9.47225C13.5266 8.44411 15.2329 7.60115 15.2833 7.59895C15.3338 7.59675 15.1275 7.81143 14.825 8.07617Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7334 20.05V13.2667L9.71465 17.9589L7.76673 20.05H3.7334Z",
    fill: "#474747"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3334 17.3L16.9678 10.425L24.2667 18.675V20.05H10.3334V17.3Z",
    fill: "#474747"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.3447,
    y: 18.1709,
    width: 6.58854,
    height: 1.87917,
    fill: "#323232"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9336 16.75L20.8753 14.825L24.2669 18.675L16.9336 16.75Z",
    fill: "#1D1D1D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8419 10.4251L6.1054 9.57715L3.73926 13.2381L9.70905 17.9589L16.8419 10.4251Z",
    fill: "#333435"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.09375 9.57713L16.9333 10.425L20.3708 7.07635L19.7865 6.12817H8.31667L6.09375 9.57713Z",
    fill: "#2A2A2A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7666 11.3416L15.2833 7.58325L10.5166 11.8916L18.3426 11.9775L20.8749 14.8249L12.8083 18.6749L17.4833 14.8249L10.7916 14.7333L7.7666 11.3416Z",
    fill: "url(#paint0_linear_5069_73058)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77832 20.05L10.3221 17.3V20.05H7.77832Z",
    fill: "#6D6D6D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5069_73058",
    x1: 14.3208,
    y1: 7.58325,
    x2: 20.8749,
    y2: 14.8249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02DEF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05E495"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSs);
export default __webpack_public_path__ + "static/media/ss.10c8d79f84374f11da92411bd2d2f876.svg";
export { ForwardRef as ReactComponent };